import { render, staticRenderFns } from "./TableMotionAlarm.vue?vue&type=template&id=7c8c8bca"
import script from "./TableMotionAlarm.vue?vue&type=script&lang=js"
export * from "./TableMotionAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports